import React from 'react';

import { flagStyles } from '../settings';

const SvgNU = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4032px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgNU;
